import { AxiosResponse } from "axios";
import { SERVERURL } from "../globals/constants";
import { Profile } from "../models/Profile";
import { Crate } from "../models/Crate";
import axios from "./axiosConfig";

export const getAllCrates = async (user: Profile) => {
  const { data } = await axios.get<Crate[]>(`${SERVERURL}/crate/getall`, {
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json;charset=UTF-8",
    },
  });

  return data;
};

export const getCrate = async (user: Profile, id: number) => {
  const { data } = await axios.get<Crate>(`${SERVERURL}/crate/get/${id}`, {
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json;charset=UTF-8",
    },
  });

  return data;
};

export const getCrateByCode = async (user: Profile, code: string) => {
  const { data } = await axios.get<Crate>(`${SERVERURL}/crate/getByCode/${code}`, {
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json;charset=UTF-8",
    },
  });

  return data;
};

export const addMaterialToCrate = async (
  user: Profile,
  crateId: number,
  materialId: number
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.post(
      `${SERVERURL}/crate/addMaterial/${crateId}`,
      { materialId },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const deleteMaterialFromCrate = async (
  user: Profile,
  crateId: number,
  materialId: number
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.delete(
      `${SERVERURL}/crate/removeMaterial/${crateId}/${materialId}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const createCrate = async (
  user: Profile,
  crateType: string
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.post(
      `${SERVERURL}/crate/create`,
      {type: crateType},
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const updateCrate = async (
  user: Profile,
  crate: Crate,
  crateId: number
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.put(
      `${SERVERURL}/crate/update/${crateId}`,
      crate,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const deleteCrate = async (user: Profile, crateId: number) => {
  try {
    const response: AxiosResponse = await axios.delete(
      `${SERVERURL}/crate/remove/${crateId}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};
